module.exports = __webpack_public_path__ + "static/sp_sm_thumbnail-5151024dd1a5fe3761c59a9ec3e430dd.jpg";